// Centralised discount labels for customer-facing UI.
// Never render raw enum codes (PALLET_MONO, ADVANCE_PAYMENT, PICKUP,
// PROMOTION, CONTRACT_PROMO) to the customer — pass them through
// discountLabel() first.
//
// Backend snapshot / audit fields are untouched: this is presentation-only.

const OFFICIAL_LABELS = {
  PALLET_MONO:      "Sconto pallet monoreferenza",
  ADVANCE_PAYMENT:  "Sconto pagamento anticipato",
  PICKUP:           "Sconto ritiro cliente",
};

// Percentuali "canoniche" del listino ufficiale — mostrate solo se non ne
// arriva una diversa dallo snapshot / preview backend.
const OFFICIAL_PCT = {
  PALLET_MONO:      2,
  ADVANCE_PAYMENT:  1,
  PICKUP:           4,
};

/**
 * Return a human-readable label for a discount entry.
 *
 * @param {object} entry - shape: { type, rule, amount, rule_label?, name?, code? }
 * @param {object} [opts] - { withPercent: boolean, pctOverride: number|string }
 * @returns {string}
 */
export function discountLabel(entry, opts = {}) {
  if (!entry) return "Sconto";
  const t = String(entry.type || entry.discount_type || "").toUpperCase();
  const official = OFFICIAL_LABELS[t];
  if (official) {
    if (opts.withPercent) {
      const pct = opts.pctOverride != null ? opts.pctOverride : OFFICIAL_PCT[t];
      return pct != null ? `${official} ${pct}%` : official;
    }
    return official;
  }
  // Future promotions: use commercial name if present.
  const name = entry.rule_label || entry.name || entry.display_name || entry.title;
  if (name && !/^[A-Z0-9_.-]+$/.test(name)) return name;
  // Fallback — do NOT expose internal codes.
  return "Sconto promozionale";
}

export function discountLabelWithPct(entry) {
  return discountLabel(entry, { withPercent: true });
}
